import { render, staticRenderFns } from "./ReceiverEditTabReceiver.vue?vue&type=template&id=cf5227ca"
import script from "./ReceiverEditTabReceiver.vue?vue&type=script&lang=js"
export * from "./ReceiverEditTabReceiver.vue?vue&type=script&lang=js"
import style0 from "./ReceiverEditTabReceiver.vue?vue&type=style&index=0&id=cf5227ca&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports